<template>
  <div class="modal fade" id="createOrganizationModal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 v-if="!editing" class="modal-title">New Organization</h5>
          <h5 v-if="editing" class="modal-title">Edit Organization</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="submitOrganization">
            <div class="form-group">
              <label for="name">Organization Name</label>
              <input
                type="text"
                class="form-control"
                id="name"
                placeholder="Organization Name"
                v-model="newOrgName"
              />
            </div>
            <div class="form-group">
              <label for="type">Type</label>
              <select
                class="form-control"
                id="type"
                v-model="newOrgType"
                required
              >
                <option
                  v-for="orgType in orgTypesToUse"
                  :key="orgType.Organization_Type_Id"
                  v-bind:value="orgType.Organization_Type_Id"
                  >{{ orgType.Name }}</option
                >
              </select>
            </div>
            <div v-if="newOrgType == 5" class="form-group">
              <label for="parent">Parent</label>
              <select
                v-if="newOrgType == 5"
                class="form-control"
                id="parent"
                v-model="newOrgParent"
                required
              >
                <option value="0" disabled>Select Parent</option>
                <option
                  v-for="org in OrgParents.filter(
                    op => op.Organization_Type_Id == 4
                  )"
                  :key="org.Organization_Id"
                  v-bind:value="org.Organization_Id"
                  >{{ org.Name }}</option
                >
              </select>
            </div>
            <div class="text-right">
              <button v-if="!editing" type="submit" class="btn btn-primary">
                Create Organization
              </button>
              <button v-if="editing" type="submit" class="btn btn-primary">
                Update Organization
              </button>
              <button
                v-if="editing"
                type="button"
                v-on:click="deleteOrganization"
                class="btn btn-link text-danger float-left"
              >
                Delete
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";

export default {
  name: "CreateOrganizationModal",
  props: {
    OrgTypes: Array,
    OrgParents: Array,
    AccountId: String,
    Organization: Object
  },
  data() {
    return {
      newOrgName: "",
      newOrgType: 0,
      newOrgParent: 0,
      editing: false,
      organizationToEdit: null,
      orgTypesToUse: []
    };
  },
  watch: {
    Organization: function() {
      if (this.Organization != null) {
        (this.newOrgName = this.Organization.Name),
          (this.newOrgType = this.Organization.Organization_Type_Id),
          (this.newOrgParent = this.Organization.Parent_Organization_Id),
          (this.editing = true);
        if (
          this.Organization.Organization_Type_Id ==
          this.OrgTypes[0].Organization_Type_Id
        ) {
          this.orgTypesToUse = this.OrgTypes;
        }
      } else {
        this.editing = false;
        this.orgTypesToUse = this.OrgTypes.filter(o => o != this.OrgTypes[0]);
        this.clearFields();
      }
    },
    OrgTypes: function() {
      this.orgTypesToUse = this.OrgTypes.filter(o => o != this.OrgTypes[0]);
      this.clearFields();
    }
  },
  mounted() {
    var view = this;
    $("#createOrganizationModal").on("hidden.bs.modal", function() {
      if (view.editing) {
        view.$emit("editClosed");
      }
    });
    $("#createOrganizationModal").on("shown.bs.modal", function() {
      $("#name").focus();
    });
  },
  methods: {
    async submitOrganization() {
      if (!this.editing) {
        await this.createOrganization();
      } else {
        await this.updateOrganization();
      }
    },
    async createOrganization() {
      $("#createOrganizationModal").modal("hide");
      var view = this;
      view.$store.commit("updateLoading", true);

      var parentOrg = 1;
      if (
        (view.$data.newOrgType == 3 || view.$data.newOrgType == 4) &&
        view.OrgParents.find(o => o.Organization_Type_Id == 2)
      ) {
        parentOrg = view.OrgParents.find(o => o.Organization_Type_Id == 2)
          .Organization_Id;
      } else if (view.$data.newOrgParent != 0) {
        parentOrg = view.$data.newOrgParent;
      }

      var organizationToCreate = {
        Name: view.$data.newOrgName,
        Parent_Organization_Id: parseInt(parentOrg),
        Organization_Type_Id: parseInt(view.$data.newOrgType),
        Account_Id: parseInt(view.$props.AccountId),
        Users: []
      };

      await this.$createOrganization(organizationToCreate)
        .then(newOrg => {
          view.$store.commit("updateLoading", false);
          view.$emit("addedOrg", newOrg);
          this.clearFields();
        })
        .catch(e => {
          console.log(e);
          view.$store.commit("updateLoading", false);
        });
    },
    async updateOrganization() {
      $("#createOrganizationModal").modal("hide");
      var view = this;
      view.$store.commit("updateLoading", true);

      var organizationToUpdate = view.$props.Organization;
      organizationToUpdate.Name = view.$data.newOrgName;
      organizationToUpdate.Parent_Organization_Id = parseInt(
        view.$data.newOrgParent
      );
      organizationToUpdate.Organization_Type_Id = parseInt(
        view.$data.newOrgType
      );
      organizationToUpdate.Account_Id = parseInt(view.$props.AccountId);

      await this.$updateOrganization(organizationToUpdate)
        .then(updatedOrg => {
          view.$store.commit("updateLoading", false);
          view.$emit("editedOrg", updatedOrg);
          this.clearFields();
        })
        .catch(e => {
          console.log(e);
          view.$store.commit("updateLoading", false);
        });
    },
    async deleteOrganization() {
      $("#createOrganizationModal").modal("hide");
      var view = this;
      view.$store.commit("updateLoading", true);
      await this.$deleteOrganization(view.$props.Organization.Organization_Id)
        .then(() => {
          view.$store.commit("updateLoading", false);
          view.$emit("deletedOrg", view.$props.Organization.Organization_Id);
          this.clearFields();
        })
        .catch(e => {
          console.log(e);
          view.$store.commit("updateLoading", false);
        });
    },
    clearFields() {
      this.newOrgName = "";
      if (this.orgTypesToUse[0]) {
        this.newOrgType = this.orgTypesToUse[0].Organization_Type_Id;
      } else {
        this.newOrgType = 0;
      }
      this.newOrgParent = 0;
    }
  }
};
</script>
